import { InfoIcon, Translation } from '@ps/web-shared-components';
import { StarsInfo } from '@ps/web-shared-ui';
import React from 'react';

import {
  TXTWCL_Need_to_upload_more_documentsX,
  TXTWCL_No_worriesX_You_can_do_so_belo_ELL,
  TXTWCL_Thanks_for_sending_them_to_usX,
  TXTWCL_Thanks_for_sending_us_your_doc_ELL,
  TXTWCL_TheyXre_just_being_processed_a_ELL,
  TXTWCL_WeXll_email_you_as_soon_as_the_ELL,
  TXTWCL_Your_identity_documents_have_n_ELL
} from './InformationMessage.messages.json';
import styles from './InformationMessage.scss';

interface Props {
  amlVerified: boolean;
}

const InformationMessage: React.FC<Props> = ({ amlVerified }) => (
  <StarsInfo className={styles.infoBox}>
    <span className={styles.infoBoxHeading}>
      <InfoIcon className={styles.infoIcon} />
      {amlVerified ? (
        <Translation tagName="b" {...TXTWCL_Your_identity_documents_have_n_ELL} />
      ) : (
        <Translation tagName="b" {...TXTWCL_Thanks_for_sending_us_your_doc_ELL} />
      )}
    </span>
    {amlVerified ? (
      <Translation {...TXTWCL_Thanks_for_sending_them_to_usX} />
    ) : (
      <>
        <Translation {...TXTWCL_TheyXre_just_being_processed_a_ELL} />{' '}
        <Translation {...TXTWCL_WeXll_email_you_as_soon_as_the_ELL} />
      </>
    )}
    <br />
    <Translation {...TXTWCL_Need_to_upload_more_documentsX} />{' '}
    <Translation {...TXTWCL_No_worriesX_You_can_do_so_belo_ELL} />
  </StarsInfo>
);

export default InformationMessage;
